import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./notify.css";

const BASE_OPTIONS = {
  position: "top-center",
  theme: "dark",
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  pauseOnHover: false,
  draggable: false,
  transition: Slide,
  className: "toast-sleek",
  bodyClassName: "toast-sleek-body",
  icon: false,
};

const notify = (message, type = "error") => {
  toast.dismiss();

  const options = {
    ...BASE_OPTIONS,
    autoClose: type === "loading" ? false : 2000,
    className: `${BASE_OPTIONS.className} toast-${type}`,
  };

  if (type === "success") return toast.success(message, options);
  if (type === "loading") return toast.info(message, options);
  return toast.error(message, options);
};

export default notify;
